// Hosts we earn a commission from. Google's link spam policy requires affiliate
// links to be qualified with rel="sponsored" (or nofollow); unqualified ones
// read as a paid link scheme. Mirrors Post::AFFILIATE_HOSTS in Ruby, which does
// the same job for links inside Markdown blog bodies.
const AFFILIATE_HOSTS = ["amzn.to", "amazon.com", "www.amazon.com", "bookshop.org"]

export function isAffiliate(url: string): boolean {
  try {
    return AFFILIATE_HOSTS.includes(new URL(url, "https://fullcast.co").host)
  } catch {
    return false
  }
}

/** rel for an outbound link — adds sponsored/nofollow when we're paid for it. */
export function relFor(url: string): string | undefined {
  if (url.startsWith("/")) return undefined
  return isAffiliate(url) ? "sponsored nofollow noopener noreferrer" : "noopener noreferrer"
}
